import { down } from "styled-breakpoints";
import styled from "styled-components";
import { Button, Title } from "sunday-component";

export const Container = styled.div`
  padding: 0 24px;
`;

export const LoginDialogTitle = styled.div`
  margin: 0 -8px;
`;

export const LoginButton = styled(Button)`
  min-width: 194px;
  ${down("sm")} {
    width: 100%;
  }
`;

export const LoginLabel = styled(Title).attrs({ level: 7 })``;
